var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-2"},[_c('span',{staticClass:"text-gray-600 whitespace-pre-line"},[_vm._v(" "+_vm._s(_vm.comments)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }